export default __webpack_public_path__ + "static/media/Social-Media-Marketing-Header.bbbb1057.png";